import type { VAlign } from '../types';


const anchorY = (rect: DOMRect, vAlign: VAlign): number => {
    if (vAlign === 'bottom') return rect.bottom;
    if (vAlign === 'center') return rect.top + rect.height / 2;

    return rect.top;
};

const menuOffsetY = (menuRect: DOMRect, menuV: VAlign): number => {
    if (menuV === 'bottom') return -menuRect.height;
    if (menuV === 'center') return -menuRect.height / 2;

    return 0;
};

const calcTop = (
    triggerRect: DOMRect,
    menuRect: DOMRect,
    triggerV: VAlign,
    menuV: VAlign
): number => {
    return anchorY(triggerRect, triggerV) + menuOffsetY(menuRect, menuV);
};


export {
    calcTop,
}
